import React, { useState } from 'react';
import { Animated, StyleSheet, TouchableOpacity } from 'react-native';
import Icon from './Icon';
import { Color, CommonProperties } from '../styles';
import RowView from './RowView';
import BaseText from './BaseText';

const NavigateRow = ({
  disableAnimation,
  onPressCallback,
  iconName,
  activeColor,
  text,
  hiddenRightIcon,
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const animation = new Animated.Value(open ? 1 : 0);
  const rotateInterpolate = animation.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '90deg'],
  });
  const onPress = () => {
    // sometimes we use these rows to open modals instead of expanding and it doesnt make sense to rotate the icon
    if (!disableAnimation) {
      setOpen(!open);
      Animated.timing(animation, {
        toValue: open ? 1 : 0,
        duration: 200,
        useNativeDriver: true,
      });
    }
    onPressCallback();
  };
  const hasActiveColor = activeColor ? styles.inactive : null;
  const applyOpenColor = open ? styles.active : hasActiveColor;

  return (
    <TouchableOpacity {...rest} onPress={onPress}>
      <RowView style={styles.containerInSection}>
        {iconName && <Icon name={iconName} size={20} style={[styles.iconLeft, applyOpenColor]} />}
        <BaseText style={[styles.text, applyOpenColor]} numberOfLines={1} ellipsizeMode={'tail'}>
          {text}
        </BaseText>

        {!hiddenRightIcon && (
          <Animated.View style={{ transform: [{ rotate: rotateInterpolate }] }}>
            <Icon name="chevronRight" size={16} style={applyOpenColor} />
          </Animated.View>
        )}
      </RowView>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  containerInSection: {
    alignItems: 'center',
    ...CommonProperties.p3,
  },
  text: {
    flex: 1,
    ...CommonProperties.h3,
  },
  iconLeft: {
    ...CommonProperties.pr5,
    textAlign: 'center',
  },
  active: {
    color: Color.active,
  },
  inactive: {
    color: Color.primary,
  },
});

export default NavigateRow;
